import React from 'react'
import { notification as AntNotification } from 'antd'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './styles.module.css'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

export const useNotification = () => {
  const success = (msg: string) => {
    AntNotification.success({
      className: styles.success,
      icon: <FontAwesomeIcon icon={faCheckCircle as IconProp} />,
      closeIcon: <FontAwesomeIcon icon={faTimes as IconProp} />,
      message: msg
    })
  }

  const info = (msg: string) => {
    AntNotification.info({
      className: styles.info,
      icon: <FontAwesomeIcon icon={faInfoCircle as IconProp} />,
      closeIcon: <FontAwesomeIcon icon={faTimes as IconProp} />,
      message: msg
    })
  }

  const warning = (msg: string) => {
    AntNotification.warning({
      className: styles.warning,
      icon: <FontAwesomeIcon icon={faInfoCircle as IconProp} />,
      closeIcon: <FontAwesomeIcon icon={faTimes as IconProp} />,
      message: msg
    })
  }

  const error = (msg: string) => {
    AntNotification.error({
      className: styles.error,
      icon: <FontAwesomeIcon icon={faTimesCircle as IconProp} />,
      closeIcon: <FontAwesomeIcon icon={faTimes as IconProp} />,
      message: msg
    })
  }

  const notification = {
    success,
    info,
    warning,
    error
  }

  return notification
}
